(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Expand color variants into separate product cards
  document.addEventListener('DOMContentLoaded', function() {
    const productItems = document.querySelectorAll('.product-grid__item:has(product-card[data-has-color-variants="true"])');
    
    productItems.forEach(async function(item) {
      const productId = item.getAttribute('data-product-id');
      const productHandle = item.querySelector('product-card').getAttribute('data-product-handle');
      const colorVariantsData = item.querySelector('product-card').getAttribute('data-color-variants');
      
      if (!colorVariantsData) return;
      
      let colorVariants;
      try {
        colorVariants = JSON.parse(colorVariantsData);
      } catch(e) {
        console.error('Failed to parse color variants:', e);
        return;
      }
      
      // Fetch full product data
      const response = await fetch(`/products/${productHandle}.js`);
      const productData = await response.json();
      
      const parentElement = item.parentElement;
      const originalClasses = item.className;
      const originalDataPage = item.getAttribute('data-page');
      
      // Create a card for each color variant
      colorVariants.forEach(function(colorVariant, index) {
        // Find the matching variant in product data
        const variant = productData.variants.find(v => 
          v.options.includes(colorVariant.name)
        );
        
        if (!variant) return;
        
        // Clone the original card
        const newItem = item.cloneNode(true);
        newItem.id = item.id + '-color-' + index;
        newItem.setAttribute('data-product-id', productId);
        newItem.setAttribute('data-page', originalDataPage);
        newItem.className = originalClasses;
        
        // Update all links to go to specific variant
        const allLinks = newItem.querySelectorAll('a');
        if (variant.id) {
          allLinks.forEach(function(link) {
            if (link.href && link.href.includes(productHandle)) {
              link.href = `/products/${productHandle}?variant=${variant.id}`;
            }
          });
        }
        
        // Update quick add form variant IDs
        const variantIdInputs = newItem.querySelectorAll('input[name="id"], input[ref="variantId"]');
        variantIdInputs.forEach(function(input) {
          if (variant.id) {
            input.value = variant.id;
          }
        });
        
        // Update product form component
        const productForm = newItem.querySelector('product-form-component');
        if (productForm && variant.id) {
          productForm.setAttribute('data-variant-id', variant.id);
        }
        
        // Update the variant JSON script
        const variantScript = newItem.querySelector('script[type="application/json"]');
        if (variantScript && variant) {
          variantScript.textContent = JSON.stringify(variant);
        }
        
        // Update swatch radio buttons
        const swatchInputs = newItem.querySelectorAll('input[type="radio"][data-variant-id]');
        swatchInputs.forEach(function(input) {
          if (input.getAttribute('data-variant-id') === String(variant.id)) {
            input.checked = true;
          } else {
            input.checked = false;
          }
        });
        
        // Update hidden title for accessibility
        const productTitle = newItem.querySelector('.product-card__link .visually-hidden');
        if (productTitle) {
          productTitle.textContent = productData.title + ' - ' + colorVariant.name;
        }
        
        // Add visible color name below product title
        const allParagraphs = newItem.querySelectorAll('p');
        allParagraphs.forEach(function(p) {
          if (p.textContent.trim() === productData.title) {
            const colorDiv = document.createElement('div');
            colorDiv.textContent = colorVariant.name;
            colorDiv.style.fontSize = '0.9em';
            colorDiv.style.color = '#666';
            colorDiv.style.marginTop = '4px';
            colorDiv.style.fontWeight = 'normal';
            p.parentNode.insertBefore(colorDiv, p.nextSibling);
          }
        });

        // Align price to top instead of center
const priceElement = newItem.querySelector('product-price');
if (priceElement) {
  priceElement.style.alignSelf = 'flex-start';
  // Also try targeting the parent container
  const priceParent = priceElement.parentElement;
  if (priceParent) {
    priceParent.style.alignItems = 'flex-start';
  }
}

// Also check for any group blocks that might be controlling alignment
const groupBlocks = newItem.querySelectorAll('.group-block-content');
groupBlocks.forEach(function(block) {
  if (block.querySelector('product-price')) {
    block.style.alignItems = 'flex-start';
  }
});
        
        // Update all images in the card
        const allImages = newItem.querySelectorAll('img');
        const slideshowSlides = newItem.querySelectorAll('slideshow-slide');

        if (variant.featured_image) {
          allImages.forEach(function(img) {
            img.src = variant.featured_image.src;
            img.srcset = variant.featured_image.src + ' 1x';
            if (img.hasAttribute('data-src')) {
              img.setAttribute('data-src', variant.featured_image.src);
            }
            img.alt = productData.title + ' - ' + colorVariant.name;
          });
          
          slideshowSlides.forEach(function(slide) {
            if (variant.featured_image.id) {
              slide.setAttribute('slide-id', variant.featured_image.id);
            }
          });
        }
        
        // Remove color swatches entirely to prevent conflicts
        const swatchPicker = newItem.querySelector('swatches-variant-picker-component');
        if (swatchPicker) {
          swatchPicker.remove();
        }
        
        const productSwatches = newItem.querySelector('product-swatches');
        if (productSwatches) {
          productSwatches.remove();
        }

        // Remove the overflow counter
        const overflowCount = newItem.querySelector('.hidden-swatches__count');
        if (overflowCount) {
          overflowCount.style.display = 'none';
        }
        
        // Insert the new card after the original
        parentElement.insertBefore(newItem, item.nextSibling);
      });
      
      // Remove the original card
      item.remove();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
